var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    style: { "display": "none" },
    onload: "resizeTextarea(1,14)"
};
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "question_form"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = {
    key: 0,
    class: "inner"
};
const _hoisted_6 = {
    key: 0,
    class: "lead"
};
const _hoisted_7 = { class: "err" };
const _hoisted_8 = {
    key: 1,
    class: "lead"
};
const _hoisted_9 = { class: "sel_wrapper" };
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    key: 0,
    class: "err"
};
const _hoisted_12 = { class: "dd_max" };
const _hoisted_13 = {
    key: 0,
    class: "err"
};
const _hoisted_14 = { class: "dd_max" };
const _hoisted_15 = {
    key: 0,
    class: "err"
};
const _hoisted_16 = ["value"];
const _hoisted_17 = {
    key: 0,
    class: "err"
};
const _hoisted_18 = { class: "bt_box" };
const _hoisted_19 = {
    key: 0,
    class: "err_list"
};
const _hoisted_20 = {
    key: 1,
    class: "inner"
};
const _hoisted_21 = {
    key: 2,
    class: "inner"
};
const _hoisted_22 = { class: "lead" };
import { ref, reactive, watch, onBeforeMount, onMounted, onUnmounted, nextTick } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import JobsModal from '@component/Modals/JobModal.vue';
import { isObjEmpty } from '@util/Common';
import moment from 'moment';
import { QuestionCount } from '@util/Consts';
const QUESTION_SCREEN = 'A';
const PAYMENT_PLAN_SCREEN = 'B';
const LIMIT_OVER_SCREEN = 'C';
export default /*@__PURE__*/ _defineComponent({
    __name: 'question_form',
    props: {
        common: {},
        errors: {},
        maximum_deadline_day: {},
        screen: {},
        remaining_question_count: {},
        used_question_count: {},
        additional_question_amount: {},
        default_deadline_day: {}
    },
    setup(__props) {
        const props = __props;
        const validate = reactive({ shot: false });
        const form = InertiaUtil.getForm({
            job_group_id: null,
            job_id: null,
            other_job_name: '',
            question_type_id: null,
            subject: '',
            content: '',
            deadline: '',
        }, props.common.path);
        const jobOptions = ref([]);
        const typeOptions = ref([]);
        // 文字数チェック
        watch(() => form.subject, (value) => {
            if (Alert.charLimitText(value, 120)) {
                form.subject = value.substring(0, 120);
            }
        });
        watch(() => form.content, (value) => {
            if (Alert.charLimitTextArea(value, 4000)) {
                form.content = value.substring(0, 4000);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onSubmit = () => {
            if (form.deadline == '') {
                form.deadline = moment(new Date()).add(props.default_deadline_day, 'days').format('YYYY/MM/DD');
            }
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('question.verify'), () => {
                validate.shot = true;
            });
        };
        const onSelectedJob = (job) => {
            var _a;
            form.job_group_id = job.job_group_id;
            form.job_id = job.job_id;
            form.other_job_name = (_a = job.other_job_name) !== null && _a !== void 0 ? _a : '';
        };
        const onInputLimit = (event) => {
            form.deadline = event.target.value;
        };
        const onClickPlan = () => {
            InertiaUtil.get(route('plan.show'));
        };
        const tryParseInt = (value) => {
            if (typeof value == 'number') {
                return value;
            }
            const num = parseInt(value);
            return !isNaN(num) ? num : 0;
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const [jobs, types] = yield Promise.all([
                    axios
                        .get('/jobs')
                        .then(res => res.data)
                        .catch(e => {
                        console.error('Failed to load jobs:', e);
                        return [];
                    }),
                    axios
                        .get('/question-types')
                        .then(res => res.data)
                        .catch(e => {
                        console.error('Failed to load question-types:', e);
                        return [];
                    }),
                ]);
                jobOptions.value = jobs;
                typeOptions.value = types;
                console.log('Loaded data:', { jobs, types });
                if (form.deadline == '') {
                    form.deadline = moment(new Date()).add(props.default_deadline_day, 'days').format('YYYY/MM/DD');
                }
            }
            catch (error) {
                console.error('Error in onBeforeMount:', error);
            }
        }));
        onMounted(() => {
            const oldFormData = sessionStorage.getItem('oldQuestionForm');
            if (oldFormData) {
                const parsedData = JSON.parse(oldFormData);
                // Populate form fields with the old data
                form.job_group_id = parsedData.job_group_id;
                form.job_id = parsedData.job_id;
                form.other_job_name = parsedData.other_job_name;
                form.question_type_id = parsedData.question_type_id;
                form.subject = parsedData.subject;
                form.content = parsedData.content;
                form.deadline = parsedData.deadline;
            }
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            // Save the form data to sessionStorage
            sessionStorage.setItem('oldQuestionForm', JSON.stringify(form));
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                (props.screen === 'A')
                    ? (_openBlock(), _createElementBlock("iframe", _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[21] || (_cache[21] = _createElementVNode("h2", null, "相談入力", -1)),
                            (props.screen === QUESTION_SCREEN)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (tryParseInt(props.remaining_question_count) <= _unref(QuestionCount).NO_REMAINING_QUESTION_COUNT)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                            _createTextVNode(" 今月は既に、基本相談回数 " + _toDisplayString(props.used_question_count) + "件 に達しています。", 1),
                                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                            _createElementVNode("span", _hoisted_7, "追加相談するには " + _toDisplayString((_a = props === null || props === void 0 ? void 0 : props.additional_question_amount) === null || _a === void 0 ? void 0 : _a.toLocaleString()) + "円/件(税込) 発生します。", 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                                            _createTextVNode(" 今月は既に相談 " + _toDisplayString(props.used_question_count) + "件 されています。", 1),
                                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                            _createTextVNode(" 今月は残り " + _toDisplayString(props.remaining_question_count) + "件 の相談ができます。 ", 1)
                                        ])),
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(onSubmit, ["prevent"])
                                    }, [
                                        _createElementVNode("dl", null, [
                                            _cache[9] || (_cache[9] = _createElementVNode("dt", { class: "must" }, [
                                                _createTextVNode(" 対象となるメンターの職種"),
                                                _createElementVNode("br", { class: "pc" }),
                                                _createElementVNode("span", { class: "must" }, "必須"),
                                                _createElementVNode("span", { class: "public" }, "公開")
                                            ], -1)),
                                            _createElementVNode("dd", null, [
                                                _createVNode(JobsModal, {
                                                    options: jobOptions.value,
                                                    form: _unref(form),
                                                    errors: props.errors,
                                                    "validate-shot": validate.shot,
                                                    onSelected: onSelectedJob,
                                                    "is-remove-other-job": true,
                                                    "is-remove-clear-btn": true
                                                }, null, 8, ["options", "form", "errors", "validate-shot"])
                                            ]),
                                            _cache[10] || (_cache[10] = _createElementVNode("dt", { class: "must" }, [
                                                _createTextVNode(" 相談タイプ"),
                                                _createElementVNode("br", { class: "pc" }),
                                                _createElementVNode("span", { class: "must" }, "必須"),
                                                _createElementVNode("span", { class: "public" }, "公開")
                                            ], -1)),
                                            _createElementVNode("dd", null, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).question_type_id) = $event)),
                                                        id: "sel",
                                                        class: "w40"
                                                    }, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "　", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (industry) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: industry.id
                                                            }, _toDisplayString(industry.name), 9, _hoisted_10));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(form).question_type_id]
                                                    ])
                                                ]),
                                                (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.question_type_id))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(props.errors.question_type_id), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("dt", { class: "must" }, [
                                                _createTextVNode(" 件名　"),
                                                _createElementVNode("span", { class: "must" }, "必須"),
                                                _createElementVNode("span", { class: "public" }, "公開")
                                            ], -1)),
                                            _createElementVNode("dd", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).subject) = $event)),
                                                    type: "text",
                                                    name: "q1",
                                                    class: "wmax inquiry-form",
                                                    placeholder: "件名",
                                                    autocomplete: "off"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).subject]
                                                ]),
                                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sub" }, "※件名だけで、おおよその内容がわかるように工夫しましょう。簡潔に、具体的に。", -1)),
                                                (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.subject))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.subject), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("dt", { class: "must" }, [
                                                _createTextVNode(" 内容　"),
                                                _createElementVNode("span", { class: "must" }, "必須"),
                                                _createElementVNode("span", { class: "public" }, "公開")
                                            ], -1)),
                                            _createElementVNode("dd", _hoisted_14, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).content) = $event)),
                                                    placeholder: "【現状・背景】\r\n①会社の概要 \r\n②現在の状況と問題、これまでの取組み \r\n③実現したいこと \r\n\r\n【相談内容】 \r\n①相談内容（課題・解決） \r\n②自分がどこまで理解しているか \r\n③その他補足",
                                                    id: "textarea_1",
                                                    oninput: "resizeTextarea(1,14)"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).content]
                                                ]),
                                                (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.content))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.errors.content), 1))
                                                    : _createCommentVNode("", true),
                                                _cache[7] || (_cache[7] = _createStaticVNode("<details class=\"hint_box\"><summary>※書き方のヒント</summary><div class=\"inner\"><div class=\"hint\"><p>全般</p><ul class=\"ul_1\"><li> ・相談の要点は、1つに絞りましょう。<br> 相談がいくつもあると、結局何を一番聞きたいのかが伝わりにくくなります。<br> 相談内容を絞り込む作業が必要です。 </li><li> ・投稿する前に、他の人に意味が伝わるか、今いちど読み返して、校正しましょう。 <ul class=\"ul_num\"><li> ① 意図を伝えるのに必要な情報をすべて盛り込んでいますか？ </li><li> ② 余分なことを書いてませんか？削れる箇所はないですか？ </li><li> ③ できるだけ事実データを用いた客観的な説明となっていますか？ </li><li>④ 論理的／構造的／具体的にまとめられていますか？</li></ul></li></ul></div><div class=\"hint\"><p>【現状・背景】</p> 次の観点から事実データを元に記述しましょう。<br> 背景から詳しく説明することで、本質的な課題・解決を見つけることに繋がります。 <ul class=\"ul_num\"><li>① 会社の概要</li><li>② 現在の状況と問題、これまでの取組み</li><li> ③ 実現したいこと（短期/中期/長期目標、納期、予算、その理由） </li></ul><p>【相談内容】</p> 次の観点から具体的に記述しましょう。 <ul class=\"ul_num\"><li> ① 相談内容（課題・解決）<br> さまざまな問題の中で、何を課題・解決したいのか明確にしましょう。その理由も。 </li><li> ② 自分がどこまで理解しているか<br> どこまで理解できているかによって、回答の仕方や内容も変わってきます。 </li><li> ③ その他補足<br> 制限事項、懸念事項、メンターに知っておいて欲しいことを記述しましょう。 </li></ul></div></div></details>", 1))
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("dt", { class: "must" }, [
                                                _createTextVNode(" 期限"),
                                                _createElementVNode("br", { class: "pc" }),
                                                _createElementVNode("span", { class: "must" }, "必須"),
                                                _createElementVNode("span", { class: "public" }, "公開")
                                            ], -1)),
                                            _createElementVNode("dd", null, [
                                                _createElementVNode("input", {
                                                    value: _unref(form).deadline,
                                                    type: "text",
                                                    name: "ymd",
                                                    class: "c-ymd",
                                                    placeholder: "日付選択▼",
                                                    onInput: onInputLimit,
                                                    autocomplete: "off"
                                                }, null, 40, _hoisted_16),
                                                _cache[8] || (_cache[8] = _createElementVNode("br", { class: "sp" }, null, -1)),
                                                _createTextVNode("（最大" + _toDisplayString((_e = props.maximum_deadline_day) !== null && _e !== void 0 ? _e : '0') + "日まで） ", 1)
                                            ]),
                                            (validate.shot && ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.deadline))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(props.errors.deadline), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            (validate.shot)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                        return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                    }), 256))
                                                ]))
                                                : _createCommentVNode("", true),
                                            _cache[14] || (_cache[14] = _createElementVNode("ul", null, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "submit",
                                                        id: "submit-button",
                                                        class: "bt_next"
                                                    }, "次へ")
                                                ])
                                            ], -1))
                                        ])
                                    ], 32)
                                ]))
                                : _createCommentVNode("", true),
                            (props.screen === PAYMENT_PLAN_SCREEN)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "lead text-margin" }, [
                                        _createTextVNode(" 相談するには有料プランを登録していただく必要があります。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 下記から登録を行なってください。"),
                                        _createElementVNode("br")
                                    ], -1)),
                                    _createElementVNode("div", { class: "bt_box" }, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    onClick: onClickPlan
                                                }, " 料金プランを変更する ")
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (props.screen === LIMIT_OVER_SCREEN)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("p", _hoisted_22, [
                                        _cache[16] || (_cache[16] = _createTextVNode(" ご相談可能な月間の上限数に達しました。")),
                                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" 今月ご相談いただいた件数は " + _toDisplayString(props.used_question_count) + "件 です。", 1),
                                        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                        _cache[19] || (_cache[19] = _createTextVNode(" 来月もご利用が続く場合には、来月になってからのご相談をお願いいたします。")),
                                        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
